import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { PageIndex } from '@common/constant/PaginateConstant';

import courseActions from '@redux/course/actions';
import { RootState } from '@redux/reducer';

const { fetchCourseDiscussionListAction } = courseActions;

export type FetchCourseDiscussionListRequestPagination = {
  page: number;
  title?: string;
};

export const COURSE_DISCUSSION_LIST_PAGE_SIZE = 3;

type UseCourseDiscussionListingProps = {
  idName?: string;
};

export const useCourseDiscussionList = ({ idName }: UseCourseDiscussionListingProps) => {
  const dispatch = useDispatch();

  const handleResetCourseDiscussion = () => {
    dispatch(fetchCourseDiscussionListAction.reset());
  };

  const { courseDiscussionListState, courseEnrollmentState } = useSelector((state: RootState) => ({
    courseDiscussionListState: state.Course.get('courseDiscussionListState'),
    courseEnrollmentState: state.Course.get('courseEnrollmentState'),
  }));

  const handleFetchCourseDiscussionList = useCallback(
    (values: FetchCourseDiscussionListRequestPagination) => {
      if (!idName) {
        return;
      }

      dispatch(
        fetchCourseDiscussionListAction.request({
          courseIdOrIdName: idName,
          pageSize: COURSE_DISCUSSION_LIST_PAGE_SIZE,
          page: values.page || PageIndex,
          title: values.title || '',
        }),
      );
    },
    [dispatch, idName],
  );

  const {
    data: courseDiscussionListData,
    error: courseDiscussionListDataError,
    isLoading: isCourseDiscussionListDataLoading,
    isError: isCourseDiscussionListDataError,
    isSuccess: isCourseDiscussionListDataSuccess,
  } = courseDiscussionListState;

  const { isLoading: isCourseEnrollmentLoading } = courseEnrollmentState;

  return {
    handleFetchCourseDiscussionList,
    courseDiscussionListData,
    courseDiscussionListDataError,
    isCourseDiscussionListDataLoading,
    isCourseDiscussionListDataError,
    isCourseDiscussionListDataSuccess,
    courseDiscussionListPage: courseDiscussionListData?.page ?? PageIndex,
    handleResetCourseDiscussion,
    isCourseEnrollmentLoading,
  };
};
